import http from './http';

export const getAddons = async () => {
  const res = await http.get('/admin/addonlist');
  return res.data;
};
